import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { HeaderPortfolio } from "../../components/headerPortfolio/header";
import { HeaderDetails } from "../../components/headerDetails/headerDetails";
import "./detailsPage.css";
import VideoPlayer from "../../components/videoPlayer/videoPlayer";

const DetailsPage = () => {
  const { state } = useLocation();
  const item = state.item;

  const [showScrollBTN, setshowScrollBTN] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 300) {
        setshowScrollBTN(true);
      } else {
        setshowScrollBTN(false);
      }
    });
  }, []);

  return (
    <div id="up" className="container" itemScope itemType="http://schema.org/VideoObject">
      <Helmet>
        <meta property="og:title" content={item.nameProject} />
        <meta property="og:description" content={item.desc} />
        <meta property="og:image" content={item.imgPath} />
        <meta property="og:url" content={window.location.href} />
      </Helmet>
      <HeaderDetails title={item.nameProject} />
      <div className="divider" />
      <section id="About" className="det flex">
        <div className="left-section" itemProp="image">
          <img src={item.imgPath} alt={item.nameProject} />
        </div>
        <div className="right-section details">
          <h3 className="title"  itemProp="name">{item.projectTitle}</h3>
          <p className="title" itemProp="description">{item.desc}</p>
        </div>
      </section>
      <div className="divider" />
      <video className="video-player" controls>
        <source src={item.video} type="video/mp4" />
      </video>
    </div>
  );
};

export default DetailsPage;
